<script lang="ts">
import "@/style/components/CardAccessSectionApplication.scss";
import { FileUrl, useRedirections } from "@/composable/applications/useFunction";
import { BButton } from "buefy";
import { ref } from "vue";
import useText from "@/composable/components/text";
import router from "@/router";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";

export default {
  name: "CardAccessSectionApplication",
  components: { BButton },
  props: {
    titleCard: {
      type: String,
      required: true,
    },
    descriptionCard: {
      type: String,
      required: true,
    },
    paramBtnClick: {
      type: LocalApplicationResult,
      required: true,
    },
    btnIcon: {
      type: String,
      required: true,
    },
    btnType: {
      type: String,
      required: true,
    },
    btnOutlined: {
      type: Boolean,
      default: false,
    },
    btnFunctionName: {
      type: String,
      required: true,
    },
  },
  emits: ["modal-value-changes", "show-modal"],
  setup(props, { emit }) {
    const url = useText().refText;
    const redirection = ref(() => {
      router.push(`/applications/${props.paramBtnClick.name}`);
    });
    const {
      downloadCharteApplication,
      downloadYamlApplication,
      updateApplication,
      downloadApplicationUploadBundle,
      downloadApplicationUploadBundleWithData,
      displayReferencesManagement,
      displayDataSetManagement,
      showDataRights,
      requestRights,
      showRequestRights,
      authorizationsManagementForApplicationUsers,
    } = useRedirections(props.paramBtnClick);
    const showCharte = async function (objectShowChartePromise: Promise<FileUrl> | undefined) {
      if (!objectShowChartePromise) {
        return;
      }
      // Délègue au parent l'ouverture de la modale charte : la fonction
      // {@code displayDataSetManagement / showRequestRights} renvoie une
      // promesse FileUrl quand la charte doit être signée . Sans ce relai ,
      // le clic restait silencieux ( promesse résolue mais aucune modale
      // affichée ) , bloquant l'utilisateur en impasse ( cf retour UX ) .
      emit("modal-value-changes", objectShowChartePromise);
      const objectShowCharte = await objectShowChartePromise;
      url.value = objectShowCharte.url;
      if (objectShowCharte.redirection) {
        redirection.value = objectShowCharte.redirection;
      }
    };
    function redirectionNameFunction() {
      switch (props.btnFunctionName) {
        case "displayReferencesManagement":
          return showCharte(displayReferencesManagement(props.paramBtnClick));
        case "displayDataSetManagement":
          return showCharte(displayDataSetManagement(props.paramBtnClick));
        case "showRequestRights":
          return showCharte(showRequestRights());
        case "showDataRights":
          return showDataRights(props.paramBtnClick);
        case "downloadYamlApplication":
          return downloadYamlApplication(props.paramBtnClick);
        case "updateApplication":
          return updateApplication(
            props.paramBtnClick.name,
            props.paramBtnClick?.configuration?.applicationDescription?.version?.version,
          );
        case "downloadApplicationUploadBundle":
          return downloadApplicationUploadBundle(props.paramBtnClick);
        case "downloadApplicationUploadBundleWithData":
          return downloadApplicationUploadBundleWithData(props.paramBtnClick);
        case "downloadCharteApplication":
          return emit("modal-value-changes", downloadCharteApplication(props.paramBtnClick.name, props.paramBtnClick.id));
        case "showCommentModal":
          return emit("show-modal", true);
        case "requestRights":
          return requestRights();
        case "authorizationsManagementForApplicationUsers":
          return authorizationsManagementForApplicationUsers();
        default:
          console.log("Sorry, we are out of.");
      }
    }
    return {
      redirectionNameFunction,
      url,
    };
  },
  methods: {

  },
};

</script>

<template>
  <div class="column card-btn-section">
    <h2
      class="card-header-title"
      :aria-label="titleCard"
    >
      {{ titleCard }}
    </h2>
    <div class="card-content">
      <span
        class="text-information"
        :aria-label="descriptionCard"
      >{{ descriptionCard }}</span>
    </div>

    <div class="card-footer">
      <slot name="action">
        <b-button
          :aria-label="titleCard"
          :type="btnType"
          :outlined="btnOutlined"
          expanded
          :icon-left="btnIcon"
          @click="redirectionNameFunction"
        />
      </slot>
    </div>
  </div>
</template>
